import { createContext, useContext, useState, useCallback } from "react";

const ThreadMoveContext = createContext(null);

export const useThreadMoveContext = () => {
  const context = useContext(ThreadMoveContext);
  return context; // Return null if not provided (no error, just no-op)
};

export function ThreadMoveProvider({ children }) {
  const [movingThreadIds, setMovingThreadIds] = useState(new Set());

  const isThreadMoving = useCallback(
    (threadId) => {
      return movingThreadIds.has(threadId);
    },
    [movingThreadIds]
  );

  const setThreadMoving = useCallback((threadId, isMoving) => {
    setMovingThreadIds((prev) => {
      const next = new Set(prev);
      if (isMoving) {
        next.add(threadId);
      } else {
        next.delete(threadId);
      }
      return next;
    });
  }, []);

  return (
    <ThreadMoveContext.Provider value={{ isThreadMoving, setThreadMoving }}>
      {children}
    </ThreadMoveContext.Provider>
  );
}
